export enum Rights {
    CREATE = 'create',
    READ = 'read',
    REPLENISH = 'replenish',
    LEND = 'lend',
    CONSUME = 'consume',
    MAINTAIN = 'maintain',
    UPDATE = 'update',
    DELETE = 'delete',
    ACCESS = 'access',
    TRIGGER = 'trigger',
    OPEN = 'open',
    ORDER = 'order',
    STATE = 'state',
    DROP_OFF = 'drop_off',
    PICK_UP = 'pick_up',
    SUPER_ADMIN = '*'
}
